module.exports = __webpack_public_path__ + "f8f9f94ebad5ec0df5856b77a0d72733.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chloe/stamps/12_PROP_VET_12.png
// module id = 112
// module chunks = 0